import { render } from "./ListeCategorieOffre.vue?vue&type=template&id=dced3ab8&ts=true"
import script from "./ListeCategorieOffre.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieOffre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__